"use client";

import { useEffect, useRef } from "react";
import { useSearchParams } from "next/navigation";
import apiClient from "@/api/config";

export default function RedirectPage() {
  const searchParams = useSearchParams();
  const hasCalled = useRef(false);

  useEffect(() => {
    if (hasCalled.current) return;
    hasCalled.current = true;

    const activitySharedCode = searchParams.get("activitySharedCode");
    const activityType = searchParams.get("activityType");
    const studentId = searchParams.get("studentId");
    const destination = searchParams.get("destination");

    if (!destination) {
      window.location.href = "/";
      return;
    }

    const decodedDestination = decodeURIComponent(destination);

    const trackAndRedirect = async () => {
      if (activitySharedCode && activityType && studentId) {
        try {
          await apiClient.put(
            `/public/studentTrackingActivity/${activitySharedCode}/${activityType}/${studentId}`,
          );
        } catch {}
      }

      window.location.href = decodedDestination;
    };

    trackAndRedirect();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFF]">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 rounded-full border-4 border-[#F3F4F6]" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#49489B] animate-spin" />
      </div>
      <p className="mt-6 text-sm text-[#6B7280] tracking-wide">
        joining class...
      </p>
    </div>
  );
}
